import * as React from "react";
import styled from "styled-components";
import "rc-slider/assets/index.css";
import Pills from '../resources/pills.svg';
import Medicine from '../resources/medicine.svg';
import Capsule from '../resources/capsule.svg';
import Drug1 from '../resources/drug1.svg';
import Drug2 from '../resources/drug2.svg';
import Drug3 from '../resources/drug3.svg';
import SliderComp from "./SliderComp";
import { VapeWrap, QuestionNumber, QuestionSection } from "./VapeView";

const DrugsView = (props) => {
    const [answers, setAnswers] = React.useState([999,999,999,999,999,999])
    const handleAnswerChange = (index, value) => {
        let newAnswers = [...answers];
        newAnswers[index-1] = value;
        setAnswers(newAnswers);
    }

    React.useEffect(() => {
        const answeredSet = props.age < 18 ? answers : answers.slice(0,5);
        const unanswered = answeredSet.some(ans => ans === 999);

        
        if (!unanswered) {
            let data = {
                DaysUsedPrescriptionOpioidDrugsNumber: answers[0],
                DaysUsedOtherPrescriptionDrugsNumber: answers[1],
                DaysUsedNonPrescriptionOpioidDrugsNumber: answers[2],
                ILL30D: answers[3],
                INJECT30D: answers[4],
                DaysShareInjectionEquipmentNumber: answers[5]
            }
            props.setDrugData(data);
            props.setNextButton(true);
            props.onAllAnswered(false);
        } else {
            props.setNextButton(false);
        }
    }, [answers]);
    

    return(
        <VapeWrap>      
                <h2>Let’s talk about Drugs:</h2>
                <h3>Over the past 30 days, how many days, if any, did you…</h3>
                <QuestionSection>
                    <div style={{marginBottom: '8px'}}>
                    <QuestionNumber>
                        <span>1</span>
                    </QuestionNumber>
                    <h3>Use prescription opioid drugs without orders given to you by your doctor?</h3>
                    </div>
                    <p>By prescription opioid drugs, we mean pain relievers such as oxycodone (OxyContin®), hydrocodone (Vicodin®), codeine, morphine, methadone, tramadol, hydromorphone, oxymorphine, tapentadol.</p>
                    <SliderComp answer={answers[0]} handleAnswerChange={(value)=>handleAnswerChange(1, value)} icon={Pills} />
                </QuestionSection>
                <QuestionSection>
                    <div style={{marginBottom: '8px'}}>
                    <QuestionNumber>
                        <span>2</span>
                    </QuestionNumber>
                    <h3>Use other prescription drugs without orders given to you by your doctor?</h3>
                    </div>
                    <p>Please exclude prescription opioid drugs. By other prescription drugs, we mean substances like barbiturates, sedatives, hypnotics, non-benzo tranquilizers.</p>
                    <SliderComp answer={answers[1]} handleAnswerChange={(value)=>handleAnswerChange(2, value)} icon={Medicine} />
                </QuestionSection>
                <QuestionSection>
                    <div style={{marginBottom: '8px'}}>
                    <QuestionNumber>
                        <span>3</span>
                    </QuestionNumber>
                    <h3>Use non-prescription opioid drugs?</h3>
                    </div>
                    <p>By non-prescription opioid drugs we mean the illegal drug heroin and illicitly made synthetic opioids such as fentanyl.</p>
                    <SliderComp answer={answers[2]} handleAnswerChange={(value)=>handleAnswerChange(3, value)} icon={Capsule} />              
                </QuestionSection>
                <QuestionSection>
                    <div style={{marginBottom: '8px'}}>
                    <QuestionNumber>
                        <span>4</span>
                    </QuestionNumber>
                    <h3>Use any other illegal drugs?</h3>
                    </div>
                    <p>Please exclude marijuana/hashish and non-prescription opioid drugs. By other illegal drugs, we mean substances like crack or cocaine, amphetamine or methamphetamine, hallucinogens (such as LSD/acid, Ecstasy/MDMA, PCP/angel dust, peyote), inhalants (sniffed substances such as glue, gasoline, paint thinner, cleaning fluid, shoe polish).</p>
                    <SliderComp answer={answers[3]} handleAnswerChange={(value)=>handleAnswerChange(4, value)} icon={Drug3} />              
                </QuestionSection>
                <QuestionSection>
                    <div style={{marginBottom: '8px'}}>
                    <QuestionNumber>
                        <span>5</span>
                    </QuestionNumber>
                    <h3>Inject any drugs?</h3>
                    </div>
                    <p>Count only injections without orders from your doctor—those you had just to feel good or to get high.</p>
                    <SliderComp answer={answers[4]} handleAnswerChange={(value)=>handleAnswerChange(5, value)} icon={Drug2} />              
                </QuestionSection>
                {props.age < 18 && <QuestionSection>
                    <div style={{marginBottom: '8px'}}>
                    <QuestionNumber>
                        <span>6</span>
                    </QuestionNumber>
                    <h3>Share injection equipment?</h3>
                    </div>
                    <p>By injection equipment, we mean needle and drug paraphernalia.</p>
                    <SliderComp answer={answers[5]} handleAnswerChange={(value)=>handleAnswerChange(6, value)} icon={Drug2} />              
                </QuestionSection>}
        </VapeWrap>
    );
}

export default DrugsView;